import React from 'react';
import PropTypes from 'prop-types';

import i18n from 'i18next';
import { ModificationTrackingForm } from 'core/forms';
import { ManageContentSectionHeader } from 'uikit/manage';
import pick from 'lodash/pick';

import { Typo } from 'uikit/content';

import getDateTimeString from '../helpers/getDateTimeString';

import styles from '../styles/multiModificationTrackingForm.module.scss';

const MultiModificationTrackingForm = ({
  componentClassName = '',
  hasTimestamp = false,
  headerElement = 'h3',
  model = {},
  onCancel = () => {},
  onSubmit = async () => {},
  onUpdate = () => {},
  schemas = [],
  titleExtra = null,
}) => (
  <>
    {schemas.map(({ description, schema, title }, index) => (
      <section key={title || `section-${index}`}>
        {title && (
          <ManageContentSectionHeader
            description={description}
            element={headerElement}
            extra={titleExtra}
            isFollowedByMagicForm
            title={title}
          />
        )}
        <ModificationTrackingForm
          className={componentClassName}
          model={pick(model, Object.keys(schema))}
          modifiedClassName={styles.isModified}
          onCancelClick={onCancel}
          onFormLoad={onUpdate}
          onSaveClick={onSubmit}
          onFormUpdate={onUpdate}
          schema={schema}
        />
      </section>
    ))}
    {hasTimestamp && (
      <div className={styles.timestamp}>
        <Typo color="secondary" variant="s01">
          {i18n.t('last-updated-by-user-on-date', {
            date: getDateTimeString(model.updated_at),
            user: model.updated_by,
          })}
        </Typo>
        <Typo color="secondary" variant="s01">
          {i18n.t('id-prefix-label', { id: model.id })}
        </Typo>
      </div>
    )}
  </>
);

MultiModificationTrackingForm.propTypes = {
  componentClassName: PropTypes.string,
  hasTimestamp: PropTypes.bool,
  headerElement: PropTypes.string,
  model: PropTypes.shape({}),
  onCancel: PropTypes.func,
  onSubmit: PropTypes.func,
  onUpdate: PropTypes.func,
  schemas: PropTypes.arrayOf(PropTypes.shape({})),
  titleExtra: PropTypes.node,
};

export default MultiModificationTrackingForm;
